module.exports = __webpack_public_path__ + "static/media/arrow_disabled_right.65249eaa.svg";